interface EventBus {
    on: (eventType: string, newHandler: (...args) => void) => void;
    emit: (eventType: string, ...args) => void;
    off: (eventType: string, handler?: (...args) => void) => void;
}
// eventBus use work for communication between base app and micro app.
export const eventBus: { instance: EventBus } = { instance: null };
